import { render, staticRenderFns } from "./npcTalk.vue?vue&type=template&id=bc0e18fa&scoped=true&"
import script from "./npcTalk.vue?vue&type=script&lang=js&"
export * from "./npcTalk.vue?vue&type=script&lang=js&"
import style0 from "./npcTalk.vue?vue&type=style&index=0&id=bc0e18fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0e18fa",
  null
  
)

export default component.exports